import Vue from 'vue';
import Audit from '@/features/audit/Audit';
import Mail from '@/features/mail/Mail';
import UserList from '@/features/user/UserList';
import UserForm from '@/features/user/UserForm';
import ClientList from '@/features/client/ClientList';
import ClientForm from '@/features/client/ClientForm';
import CycleList from '@/features/cycle/CycleList';
import CycleForm from '@/features/cycle/CycleForm';
import ProjectList from '@/features/project/ProjectList';
import ProjectForm from '@/features/project/ProjectForm';
import TableManagerForm from '@/features/table-manager/TableManagerForm';
import TableManagerList from '@/features/table-manager/TableManagerList';
import Settings from '@/features/settings/Settings';
import BillingReportList from '@/features/billing-report/BillingReportList';
import BillingReportForm from '@/features/billing-report/BillingReportForm';
import ZohoReportCredentialList from '@/features/zoho-report-credential/ZohoReportCredentialList';
import ZohoReportCredentialForm from '@/features/zoho-report-credential/ZohoReportCredentialForm';
import ZohoReportGroupList from '@/features/zoho-report/ZohoReportGroupList';
import ZohoReportGroupForm from '@/features/zoho-report/ZohoReportGroupForm';
import ZohoReportView from '@/features/zoho-report/ZohoReportView';
import LoadConfForm from '@/features/load-conf/LoadConfForm';
import LoadConfList from '@/features/load-conf/LoadConfList';

Vue.component('audit', Audit);
Vue.component('audit', Mail);
Vue.component('user-list', UserList);

export default [
  {
    path: 'audit',
    name: 'audit',
    component: Audit,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'mail',
    name: 'mail',
    component: Mail,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'client',
    name: 'client-list',
    component: ClientList,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'client/:id',
    name: 'client-form',
    component: ClientForm,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'table-manager',
    name: 'table-manager-list',
    component: TableManagerList,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'table-manager/:id',
    name: 'table-manager-form',
    component: TableManagerForm,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'cycle',
    name: 'cycle-list',
    component: CycleList,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'cycle/:id',
    name: 'cycle-form',
    component: CycleForm,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'project',
    name: 'project-list',
    component: ProjectList,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'project/:id',
    name: 'project-form',
    component: ProjectForm,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'user',
    name: 'user-list',
    component: UserList,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin', 'admin_cliente'] },
  },
  {
    path: 'user/:id',
    name: 'user-form',
    component: UserForm,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin', 'admin_cliente'] },
  },
  {
    path: 'load-conf',
    name: 'load-conf-list',
    component: LoadConfList,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin', 'admin_cliente'] },
  },
  {
    path: 'load-conf/:id',
    name: 'load-conf-form',
    component: LoadConfForm,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin', 'admin_cliente'] },
  },
  {
    path: 'settings',
    name: 'settings-list',
    component: Settings,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'billing-report',
    name: 'billing-report-list',
    component: BillingReportList,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'billing-report/:id',
    name: 'billing-report-form',
    component: BillingReportForm,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin'] },
  },
  {
    path: 'zoho-report-credential',
    name: 'zoho-report-credential-list',
    component: ZohoReportCredentialList,
    meta: { requiresAuth: true, requireRoles: ['master'] },
  },
  {
    path: 'zoho-report-credential/:id',
    name: 'zoho-report-credential-form',
    component: ZohoReportCredentialForm,
    meta: { requiresAuth: true, requireRoles: ['master'] },
  },
  {
    path: 'zoho-report-group',
    name: 'zoho-report-group-list',
    component: ZohoReportGroupList,
    meta: { requiresAuth: true, requireRoles: ['master'] },
  },
  {
    path: 'zoho-report-group/:id',
    name: 'zoho-report-group-form',
    component: ZohoReportGroupForm,
    meta: { requiresAuth: true, requireRoles: ['master'] },
  },
  {
    path: 'zoho-report-view',
    name: 'zoho-report-view',
    component: ZohoReportView,
    meta: { requiresAuth: true, requireRoles: ['master'] },
  },
];



// WEBPACK FOOTER //
// ./src/router/AdminRoutes.js